import React from "react";

import type { BorgContextPin } from "../models/borg-types";

import { CollapsiblePinList } from "./_collapsible-pin-list";
import { ContextChip } from "./_context-chip";
import { ContextPicker } from "./_context-picker";

export interface ContextBarConfig {
	pins: ReadonlyArray<BorgContextPin>;
	onRemovePin: (pin: BorgContextPin) => void;
	onAddPin: (pin: BorgContextPin) => void;
	removedPins: ReadonlyArray<BorgContextPin>;
}

interface ContextBarProps {
	pins: ReadonlyArray<BorgContextPin>;
	onRemovePin: (pin: BorgContextPin) => void;
	onAddPin: (pin: BorgContextPin) => void;
	removedPins: ReadonlyArray<BorgContextPin>;
}

export const ContextBar: React.FC<ContextBarProps> = ({ pins, onRemovePin, onAddPin, removedPins }) => (
	<CollapsiblePinList
		pins={pins}
		renderPin={(pin) => <ContextChip onRemove={() => onRemovePin(pin)} pin={pin} />}
		suffix={<ContextPicker onAddPin={onAddPin} removedPins={removedPins} />}
	/>
);
